/** 원격검침 주파수대역 */
export enum RemoteMeteringBand {
  BAND_424_447 = "424-447MHz",
  BAND_920_923 = "920-923MHz",
}

/** 동축케이블 주파수대역 */
export enum CoaxialBand {
  VHF = "54-216MHz",
  UHF = "216-400MHz",
  HIGH = "400MHz+",
}

/** RF카드 주파수대역 */
export enum RfCardBand {
  LF = "125-134kHz",
  HF_PROXIMITY = "13.56MHz-proximity",
  HF_VICINITY = "13.56MHz-vicinity",
  UHF = "860-960MHz",
}

/** 원격검침 수신감도 주파수대역별 기준 */
export const REMOTE_METERING_THRESHOLDS = {
  [RemoteMeteringBand.BAND_424_447]: { min: -110, max: -100 }, // dBm
  [RemoteMeteringBand.BAND_920_923]: { min: -137, max: -110 },
} as const;

/** 동축케이블 전계강도 주파수대역별 상한 */
export const COAXIAL_FIELD_STRENGTH_THRESHOLDS = {
  [CoaxialBand.VHF]: 20, // μV/m
  [CoaxialBand.UHF]: 15,
  [CoaxialBand.HIGH]: 10,
} as const;

/** RF카드 인식거리 주파수대역별 상한 */
export const RF_RECOGNITION_DISTANCE_THRESHOLDS = {
  [RfCardBand.LF]: 0.1, // 10cm = 0.1m
  [RfCardBand.HF_PROXIMITY]: 0.1, // 10cm (근접식, ISO 14443)
  [RfCardBand.HF_VICINITY]: 1.5, // 1.5m (근거리, ISO 15693)
  [RfCardBand.UHF]: 12, // 12m
} as const;
